import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Navbar from './Components/Navbar'
import Footer from './Components/Footer'
import Home from './Pages/Home'
import Error404 from './Components/Error404'

export default function App() {
  return (
    <>
        <BrowserRouter>
            <Navbar/>
                <Routes>
                    <Route path="/" element={<Home/>} />
                    <Route path="/*" element={<Error404/>}/>
                </Routes>
            <Footer/>
        </BrowserRouter>
    </>
  )
}
